import styled from "styled-components";
import { useSelector } from "react-redux";

const About = () => {
  const settings = useSelector((state) => state.settings);
  return (
    <Container className="centered col" isPowered={settings.homePowerIsOn}>
      <p>My children enjoy playing Connect Four at home, but they often accidentally release all the chips or make "mistakes".</p>
			<p>Connect Four games do exist online, but I wanted to make my own for them to play.</p>
			<p>There are a couple hidden modes of play - see if you can find them!</p>
    </Container>
  );
};

export default About;

const Container = styled.section`
  flex-direction: column;
  p {
    width: 100%;
    color: ${(props) => (props.isPowered ? `var(--power2)` : `white`)};
    max-width: 45ch;
    text-align: left;
  }
  p:last-of-type {
    margin-bottom: 3em;
    width: fit-content;
  }
`;
